// Auto-generated by scripts/sync-i18n-json-to-ts.js - DO NOT EDIT DIRECTLY.
// Per non-base locale: how many leaf keys shipped UNTRANSLATED (fell back to
// English) in this build, out of the total, plus a few sample key paths. Read at
// boot to report i18nUntranslatedStringsShipped when a build slipped past the
// missing/stale gate. See design-docs/i18n-translation.md.

export interface I18nFallbackStat {
  total: number;
  untranslated: number;
  sampleKeys: string[];
}

export const I18N_FALLBACK_STATS: { [locale: string]: I18nFallbackStat } = {
  "es": {
    "total": 3551,
    "untranslated": 0,
    "sampleKeys": []
  },
  "nl": {
    "total": 3551,
    "untranslated": 0,
    "sampleKeys": []
  },
  "fr": {
    "total": 3551,
    "untranslated": 0,
    "sampleKeys": []
  }
};
